import React from 'react';

import InfoGeneral from '../InfoGeneral/InfoGeneral';
import AccountDestiny from './AccountDestiny/AccountDestiny';
import InfoSalaryResume from './InfoSalaryResume/InfoSalaryResume';

const DetailsCollaborator = ({ collaborator, methodForPay }) => {
  return (
    <div>
      <span className='bold-20'>Detalles de colaborador</span>
      <InfoGeneral collaborator={collaborator} />
      <InfoSalaryResume collaborator={collaborator} />
      <AccountDestiny collaborator={collaborator} methodForPay={methodForPay} />
    </div>
  );
};

export default DetailsCollaborator;
